import _ from 'lodash';

export function getUsers(state) {
  return state.users.items;
}

export function getUserById(state, id) {
  const users = getUsers(state);
  return users[id] || {};
}

export function getUsersById(state, ids = []) {
  const users = [];

  ids.forEach((id) => {
    const user = getUserById(state, id);
    if (user) {
      users.push(user);
    }
  });

  return users;
}

function getFetching(state) {
  return state.users.fetching;
}

export function getFetchUserIds(state) {
  const requestingIds = _.keys(_.pickBy(getFetching(state)));
  const fetchedIds = Object.keys(getUsers(state));
  return _.concat(requestingIds, fetchedIds);
}

export function getFilteredFetchUserIds(state, userIdsToFetch) {
  return _.difference(_.map(userIdsToFetch, _.toString), getFetchUserIds(state));
}
